export * as Table from './styled/table'
